import clsx from 'clsx';
import NewsletterSignUp from '../NewsletterSignup';
import React from 'react';
import styles from './middleStyles';

const Middle = ({ currentUser, gdprColorScheme, gdpr, isSubscribed, newsletter, newsletterId }) => {
  return (
    <div className={styles.mainContainer} id="feed-newsletter-container-middle">
      <div className={clsx(styles.middleContainer, 'container')}>
        <div className={styles.middleWrapper}>
          <div className={styles.newsletterIntro}>
            <div className={styles.newsletterName}>{newsletter.name} Newsletter</div>
            <div className={styles.newsletterDescription}>{newsletter.description}</div>
          </div>
          <div className={styles.newsletterAction}>
            <NewsletterSignUp
              newsletterId={newsletterId}
              isSubscribed={isSubscribed}
              currentUser={currentUser}
              newsletterName={newsletter.name}
              gdpr={gdpr}
              gdprColorScheme={gdprColorScheme}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Middle;
